export var NetsuiteAutomationOperation = /*#__PURE__*/ function(NetsuiteAutomationOperation) {
    NetsuiteAutomationOperation["Upsert"] = "UPSERT";
    NetsuiteAutomationOperation["UpsertRelatedRecords"] = "UPSERT_RELATED_RECORDS";
    return NetsuiteAutomationOperation;
}({});
export var NetsuiteAutomationSource = /*#__PURE__*/ function(NetsuiteAutomationSource) {
    NetsuiteAutomationSource["NativeIntegration"] = "NATIVE_INTEGRATION";
    NetsuiteAutomationSource["GlobalCompany"] = "GLOBAL_COMPANY";
    NetsuiteAutomationSource["GlobalProject"] = "GLOBAL_PROJECT";
    NetsuiteAutomationSource["ErpNativeToExternal"] = "ERP_NATIVE_TO_EXTERNAL";
    return NetsuiteAutomationSource;
}({});
